import { CustomButton, Modal, SvgSuccessTick } from '@ui-kit'
import { MODAL_POPUP_ACTIONS, NAMESPACES } from '../../../utils/constants'
import { PENDING_INTAKE_POPUP_MESSAGE } from '../../../constants/formattedMessages'
import { useTenantNavigate } from '@app-store'
import { useParams } from 'react-router-dom'
import { MultiProductModalType } from '../../../utils/types'
import { getStatusUpdateNotificationParts } from '../../../utils/multiProductEnrollment.utils'

interface MultiProductPopupModalProps {
  activeModal: MultiProductModalType
  closeModal: () => void
  onConfirmClick?: (modalType?: string) => void
  latestStatus?: string
}

export const MultiProductPopupModal = ({
  activeModal,
  closeModal,
  onConfirmClick,
  latestStatus,
}: MultiProductPopupModalProps) => {
  const navigate = useTenantNavigate()
  const { entityid: entityId, layoutid, id } = useParams()

  const navigateToQueue = () => {
    navigate(`/manage-queue/dynamic-queue/${entityId}/${layoutid}/${id}`)
  }

  const MODAL_CONTENT: Record<
    Exclude<MultiProductModalType, null>,
    () => React.ReactNode
  > = {
    PENDING_INTAKE: () => (
      <>
        <SvgSuccessTick />
        <span className="text-base font-medium">
          {NAMESPACES.PENDING_INTAKE_POPUP_HEADER}
        </span>
        <div className="text-xs leading-snug text-center">
          {PENDING_INTAKE_POPUP_MESSAGE}
        </div>
        <CustomButton
          isFilled
          onClick={async () => {
            await onConfirmClick?.()
            navigateToQueue()
          }}
        >
          {MODAL_POPUP_ACTIONS.OK_UPPERCASE}
        </CustomButton>
      </>
    ),
    INTAKE_COMPLETE: () => (
      <>
        <SvgSuccessTick />
        <span className="text-base font-medium">
          {NAMESPACES.INTAKE_COMPLETE_POPUP_HEADER}
        </span>
        <div className="text-xs leading-snug text-center">
          <p>{NAMESPACES.INTAKE_COMPLETE_POPUP_MESSAGE}</p>
        </div>
        <CustomButton
          isFilled
          onClick={() => {
            onConfirmClick?.()
            closeModal()
          }}
        >
          {MODAL_POPUP_ACTIONS.PROCEED_TO_INTAKE}
        </CustomButton>
      </>
    ),
    ALL_CASES_QUICK_DENIED: () => (
      <>
        <SvgSuccessTick />
        <span className="text-base font-medium">
          {NAMESPACES.ALL_CASES_QUICK_DENIED_POPUP_HEADER}
        </span>
        <div className="text-xs leading-snug text-center">
          <p>{NAMESPACES.ALL_CASES_QUICK_DENIED_POPUP_MESSAGE}</p>
        </div>
        <CustomButton
          isFilled
          onClick={() => {
            onConfirmClick?.()
            closeModal()
            navigateToQueue()
          }}
        >
          {MODAL_POPUP_ACTIONS.OK_UPPERCASE}
        </CustomButton>
      </>
    ),
    STATUS_UPDATE_NOTIFICATION: () => {
      const { before, status, after } =
        getStatusUpdateNotificationParts(latestStatus)
      return (
        <>
          <SvgSuccessTick />
          <span className="text-base font-medium">
            {NAMESPACES.STATUS_UPDATE_NOTIFICATION_HEADER}
          </span>
          <div className="text-xs leading-snug text-center">
            <p>
              {before}
              <strong>{status}</strong>
              {after}
            </p>
          </div>
          <CustomButton
            isFilled
            onClick={async () => {
              await onConfirmClick?.()
              closeModal()
              navigateToQueue()
            }}
          >
            {MODAL_POPUP_ACTIONS.OK_UPPERCASE}
          </CustomButton>
        </>
      )
    },
  }

  return (
    <Modal
      isOpen
      closeModal={closeModal}
      showCloseButton={true}
      width="min-w-[30vw] max-w-[70%]"
    >
      <div className="flex flex-col p-[0.87rem] w-[28.625rem] gap-5 mx-auto">
        <div className="flex flex-col gap-3">
          <div className="flex flex-col items-center gap-5">
            {activeModal ? MODAL_CONTENT[activeModal]() : null}
          </div>
        </div>
      </div>
    </Modal>
  )
}
